import type { AiChatMessage } from "./ai.types";

/** A tab retains its own thread; a different device's last activity never hijacks it. */
export function restoredConversationId(userId: string, ownedIds: readonly string[]): string | undefined {
  try {
    const saved = sessionStorage.getItem(`omnisynia.conversation.${userId}`);
    if (saved && ownedIds.includes(saved)) return saved;
  } catch { /* Storage may be unavailable in a private WebView. */ }
  return ownedIds[0];
}

export function rememberConversation(userId: string, conversationId: string): void {
  try { sessionStorage.setItem(`omnisynia.conversation.${userId}`, conversationId); }
  catch { /* Server history remains available even if tab storage is disabled. */ }
}

export function mergeConversationHistory(remote: readonly AiChatMessage[], current: readonly AiChatMessage[]): AiChatMessage[] {
  return remote.filter(m => m.role === "user" || m.role === "assistant").map(message => {
    const previous = current.find(m => m.role === message.role && m.image &&
      message.content === m.content + "\n[Foto adjunta en la sesión; no guardada en el historial.]");
    return previous ?? { role: message.role, content: message.content };
  });
}
